import type { User } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { COMMON_FORM_FIELDS_TRANSLATED } from '../form';
import { APP_DICTIONARY } from '../root';

type TranslatedUserKeys = keyof Pick<
  User,
  | 'customer'
  | 'email'
  | 'locale'
  | 'metersStatsNotification'
  | 'name'
  | 'password'
  | 'permissions'
  | 'phone'
  | 'tenant'
  | 'userType'
>;

export const USER_FIELDS_TRANSLATED = defineMessages<TranslatedUserKeys>({
  customer: { id: 'app.common.user.fields.customer' },
  password: APP_DICTIONARY.password,
  email: APP_DICTIONARY.email,
  locale: { id: 'app.common.user.fields.locale' },
  name: { id: 'app.common.user.fields.name' },
  permissions: { id: 'app.common.user.fields.permissions' },
  phone: COMMON_FORM_FIELDS_TRANSLATED.phone,
  userType: { id: 'app.common.user.fields.userType' },
  metersStatsNotification: { id: 'app.common.user.fields.metersStatsNotification' },
  tenant: { id: 'app.common.user.fields.tenant' },
});
